<template>
  <b-jumbotron header-level="4">
    <template #header>{{ course.name }}</template>
    <hr class="my-4">
    <div v-html="course.description"></div>
  </b-jumbotron>
</template>

<script>
export default {
  name: "DescriptionView",
  props: {
    course: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        description: ''
      })
    }
  }
}
</script>

<style scoped>

</style>
